import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FeatherModule } from 'angular-feather';
import { AngularSplitModule } from 'angular-split';
import { NgChartsModule } from 'ng2-charts';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { UiSwitchModule } from 'ngx-ui-switch';
import { HelpersModule } from 'src/app/core/helpers/helpers.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { BatchCommandsComponent } from './batch-commands/batch-commands.component';
import { CommandsComponent } from './commands/commands.component';
import { EventsComponent } from './events/events.component';
import { HyundaiPositionComponent } from './hyundai-position/hyundai-position.component';
import { LastPositionComponent } from './last-position/last-position.component';
import { MxtStatusComponent } from './mxt-status/mxt-status.component';
import { PacketsRoutingModule } from './packets-routing.module';
import { SetupAtivacaoComponent } from './setup-ativacao/setup-ativacao.component';

@NgModule({
  declarations: [
    EventsComponent,
    LastPositionComponent,
    CommandsComponent,
    MxtStatusComponent,
    SetupAtivacaoComponent,
    HyundaiPositionComponent,
    BatchCommandsComponent,
  ],
  imports: [
    UiSwitchModule,
    PacketsRoutingModule,
    CommonModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbTooltipModule,
    ScrollingModule,
    NgbAccordionModule,
    NgSelectModule,
    NgChartsModule,
    MatSelectModule,
    FormsModule,
    MatInputModule,
    FeatherModule,
    NgxJsonViewerModule,
    HelpersModule,
    ReactiveFormsModule,
    ClipboardModule,
    GoogleMapsModule,
    SharedModule,
    AngularSplitModule,
    ReactiveFormsModule,
    ],
  providers: [],
})
export class PacketsModule {}
